module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp3_5010.d40e96bf.png";